<template>
    <div class="mt-4 px-3">
        <div class="block text-gray-600 text-xl">New Application</div>
        <form action="" class="mt-3" v-if="showApplicantsSelect && store.getters.user.relationships && store.getters.user.relationships.length > 0">
            <select id="applicant" name="applicant" v-model="applicant" @change="updateForms" class="w-full py-3 px-4 border border-border rounded focus:outline-none cursor-pointer">
                <option value="">Select a Member, Spouse or Dependant</option>
                <option :value="store.getters.user.id" class="cursor-pointer">{{ store.getters.user.first + ' ' + store.getters.user.last }}</option>
                <option v-for="(applicant, index) in store.getters.user.relationships.filter(application => application.active === true)" :key="index" :value="applicant.id" class="cursor-pointer">{{ applicant.first + ' ' + applicant.last }}</option>
            </select>
        </form>
        <div class="mb-6 text-gray-600" v-if="applicant !== ''">Select application below to start</div>
        <div class="flex w-full items-center justify-center" v-if="loading">
            <svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="spinner" class="svg-inline--fa fa-spinner fa-w-16 fa-spin w-16 h-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M296 48c0 22.091-17.909 40-40 40s-40-17.909-40-40 17.909-40 40-40 40 17.909 40 40zm-40 376c-22.091 0-40 17.909-40 40s17.909 40 40 40 40-17.909 40-40-17.909-40-40-40zm248-168c0-22.091-17.909-40-40-40s-40 17.909-40 40 17.909 40 40 40 40-17.909 40-40zm-416 0c0-22.091-17.909-40-40-40S8 233.909 8 256s17.909 40 40 40 40-17.909 40-40zm20.922-187.078c-22.091 0-40 17.909-40 40s17.909 40 40 40 40-17.909 40-40c0-22.092-17.909-40-40-40zm294.156 294.156c-22.091 0-40 17.909-40 40s17.909 40 40 40c22.092 0 40-17.909 40-40s-17.908-40-40-40zm-294.156 0c-22.091 0-40 17.909-40 40s17.909 40 40 40 40-17.909 40-40-17.909-40-40-40z"></path></svg>
        </div>
        <div class="grid grid-cols-2 gap-2" v-if="!loading && applicant !== ''">
            <ApplicationFormCard v-for="(form, index) in forms" :key="form.id || index" :form="form" :applicant="applicant" />
        </div>
    </div>
</template>

<script>
import { useStore } from 'vuex'
import { ref, onBeforeMount } from 'vue'
import ApplicationFormCard from '@/views/partials/ApplicationFormCard'

export default {
    name: 'ApplicationFormsList',
    components: {
        ApplicationFormCard
    },
    props: {
        showApplicants: {
            default: false
        }
    },
    setup (props) {
        const store = useStore()
        const forms = ref([])
        const applicant = ref('')
        const showApplicantsSelect = ref()
        const loading = ref(false)

        onBeforeMount(() => {
            showApplicantsSelect.value = props.showApplicants

            if (store.getters.user.relationships && store.getters.user.relationships.length > 0) {
                applicant.value = ''
            } else {
                applicant.value = store.getters.user.id
            }

            forms.value = store.getters.forms

            store.dispatch('GET_ME')
            store.dispatch('GET_FORMS').then(() => {
                forms.value = store.getters.forms
            })
        })

        function updateForms () {
            loading.value = true

            store.dispatch('GET_FORMS', applicant.value).then(() => {
                forms.value = store.getters.forms
                loading.value = false
            })
        }

        return {
            store,
            forms,
            applicant,
            updateForms,
            showApplicantsSelect,
            loading
        }
    }
}
</script>

<style scoped>

</style>
